module.exports = __webpack_public_path__ + "img/trend-up.4966cc09.png";